<div class="item">
    <div class="icon">
        <i class="fa fa-cubes"></i>
    </div>
    <div class="content">
        <div class="title">{{ item?.code || ('#' + item?.id) }}</div>
        <div class="subtitle">{{ item?.id }}</div>
    </div>
    <div class="status" [ngClass]="statusClass">
        {{ statusLabel | translate }}
    </div>
</div>
